
import React, { useRef, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import { formatDateMoment, getCurrentDateTime,capitalizeWords,convertToUpperCase } from '../../../../utils/utils';

const ProductInformationSheet = ({open, onClose, data = {}, patientInfo={},isVisible=false }) => {
  const printContentRef = useRef(null);
  const topLevel = patientInfo?.patient_information?.print_details?.find((it) => it?.label_type == '6')
  const topLogo = topLevel?.brand_logo;
  const brand_name = topLevel?.brand_name;
  const address = topLevel?.org_description || '22WJ+JV7, S Central Rd, MIDC Industrial Area, Shiravane, Nerul, Navi Mumbai, Maharashtra 400705, www.immunoact.com';
     const reactToPrintFn = useReactToPrint({
       content: () => printContentRef.current,
       onAfterPrint: onClose,
       removeAfterPrint: true,
     });
  
       useEffect(() => {
         if (open) {
           const timer = setTimeout(() => {
             if (printContentRef.current) {
               reactToPrintFn();
             }
           }, 300);
           
           return () => clearTimeout(timer);
         }
       }, [open]);
    const fields = [
      { label: "Product Name", value: capitalizeWords(patientInfo?.product_name) },
      { label: "Programme Code/Commercial Code", value:patientInfo?.program_code },
      { label: "ImmunoACT Patient ID", value: patientInfo?.immunoactPatientId },
      { label: "Hospital Patient ID", value: patientInfo?.hospital_patient_id },
      { label: "Patient Name", value: capitalizeWords(patientInfo?.patientName) },
      { label: "Patient Initials", value: convertToUpperCase(patientInfo?.patient_information?.patient_initials)  },
      { label: "Patient Bodyweight(Kg)", value: patientInfo?.patient_information?.body_weight },
      { label: "Patient Bodyweight Submitted", value: formatDateMoment(patientInfo?.created_at) },
      { label: "Disease Indication", value: capitalizeWords(patientInfo?.disease) },
      { label: "Patient DOB", value: formatDateMoment(patientInfo?.patient_information?.dob) },
      { label: "Hospital ID", value: patientInfo?.patient_information?.hospital_id },
      { label: "Hospital Name", value: patientInfo?.patient_information?.hospital },
      { label: "Manufacturing date", value: formatDateMoment(patientInfo?.mfg_date) },
      { label: "Expiry date", value: patientInfo?.expiry_date ? formatDateMoment(patientInfo?.expiry_date):'' },
      { label: "Batch Number", value:patientInfo?.batch_no },
      { label: "Total CAR-T cells filled(x10⁶ Cells)", value: data?.total_car_t_cells_filled },
      { label: "CAR-T cells Dose prepared (cells/kg)", value: data?.car_t_dose_per_kg },
      { label: "Product volume(ml)", value: '100' },
    ];

  return (
      <div style={{ display: isVisible ? 'block' : 'none' }}>
      <div ref={printContentRef}>
      <div style={{ 
        width: '210mm',
        minHeight: '297mm',
        padding: '15mm',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        fontSize: '10pt',
        backgroundColor: 'white',
        lineHeight: '1.2',
        boxSizing: 'border-box',
        position: "relative"
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#2E5598',
            marginBottom: '5px',
            textAlign: "center",
            display: "flex",
            flexDirection: "column"
          }}>
           <img src={topLogo}  style={{margin:"0 auto", maxWidth:"200px",maxHeight: "100px"}} />
           {brand_name || 'Immunoadoptive Cell Therapy Pvt Ltd'}
          </div>
          <div style={{
            fontSize: '11px',
            color: '#777',
            lineHeight: '1.4'
          }}>
            {address}
          </div>
          <div style={{
            borderTop: '2px solid #D8D8D8',
            margin: '15px 0',
            width: '100%'
          }}></div>
          
          {/* Form Title */}
          <div style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#000',
            margin: '10px 0'
          }}>
           Product information sheet
          </div>
        </div>
        
        <div style={{ paddingBottom: '50px' }}> {/* Add padding to prevent content overlap with footer */}
              <div>
 <div className="section-title">Product Information Sheet</div>
 <table className="info-table">
        <tbody>
          {fields.map(({ label, value },index) => (
            <tr key={index}>
              <td className="label" style={{width:"50%"}}>{label}</td>
              <td className="value" style={{width:"50%"}}>
                {value !== undefined && value !== ""
                  ? value
                  : "—"}
              </td>
            </tr>
          ))}
          </tbody>
          </table>

  <div className="section-title mt-20">Remarks</div>
          <div className="section-box">
  <div className="field-grid">{data?.remarks}</div>
  </div>
              </div>
          {/* Date Section - Above the footer */}
        <div className="date-section">
          <div className="date-row">
            <div className="date-column">
              <div className="date-label">Submitted By:</div>
              <div className="date-name">{capitalizeWords(data?.reviewed_by)} {data?.submitted_by_role ? '('+data?.submitted_by_role+')':''}</div>
              <div className="date-time">{data?.created_at ? getCurrentDateTime(data?.created_at):''}</div>
            </div>
            
            <div className="date-column">
              <div className="date-label">Approved By:</div>
              <div className="date-name">{capitalizeWords(data?.approved_by)}{data?.approved_by_role ? '('+data?.approved_by_role+')':''}</div>
              <div className="date-time">{data?.approved_at ? getCurrentDateTime(data?.approved_at):''}</div>
            </div>
          </div>
        </div>
        </div>
         
        {/* Fixed Footer at bottom of last page */}
        <div className="footer-section">
          <div className="footer-content">
            <div className="declaration-text">
              This document is system generated and does not require a signature.
            </div>
            <div className="confidential-text">
              Confidential document, property of &lsquo;Immunoadoptive Cell Therapy Private Limited&lsquo;, 
              duplication, disclosure and circulation is strictly prohibited
            </div>
          </div>
          <div className="timestamp-section">
            <span className="timestamp-item">
              Printed on: {getCurrentDateTime()}
            </span>
            <span className="timestamp-item">
              Created On: {getCurrentDateTime(data?.created_at)}
            </span>
          </div>
        </div>
        
      </div>
      
      <style>
        {`
          @page {
            size: A4;
            margin: 2mm;
          }
          
          .page-break {
            page-break-before: always;
            break-before: page;
          }
          
          .print-page {
            font-family: Arial, sans-serif;
            font-size: 14px;
            color: #000;
          }
          
          .head-title {
            text-align: center;
            font-weight: bold;
            color: #3571FF;
            font-size: 25px;
          }
          
          .section-title {
            font-size: 14px;
            font-weight: 700;
            padding: 11px 8px 11px;
            letter-spacing: 0.5px;
            background-color: #EAEBEF;
            border-radius: 10px 10px 0 0;
            margin-bottom: 0;
            border: 1px solid #D8D8D8;
            border-bottom: none;
          }
          
          .section-box {
            background: #f8fafc;
            padding: 16px;
            margin-bottom: 20px;
            border: 1px solid #D8D8D8;
            border-top: none;
            border-radius: 0 0 4px 4px;
          }
          
          .field-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px 24px;
          }
          
          .field-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
          
          .field-item.full-width {
            /* This class is kept for backward compatibility */
          }
          
          .field-label {
            font-weight: 600;
            color: #333;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }
          
          .field-value {
            color: #545454;
            background: #ffffff;
            font-size: 12px;
            min-height: 15px;
            word-break: break-word;
          }
          
          .field-value.full-width-value {
            width: 100%;
          }
          .info-table{
            width: 100%;
            }
          .info-table td {
          padding: 7px;
        }
          /* Footer styles */
          .footer-section {
            position: absolute;
            bottom: 15mm; /* Match the page padding */
            left: 15mm;
            right: 15mm;
            margin-top: auto;
          }
          
          .footer-content {
            text-align: center;
            color: #858585;
            font-size: 10px;
            line-height: 1.4;
            margin-bottom: 5px;
          }
          .date-row {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            margin-top:30px;
          }
            .date-label{
            color:#3571FF;
            font-size:10px;
            }
            .date-time{
            color:#A3A3A3;
             font-size:8px;
            }
              .date-name {
            font-size: 11px;
            margin-bottom: 4px;
            color: #545454;
          }
          .declaration-text {
            margin-bottom: 3px;
          }
          
          .confidential-text {
            font-style: italic;
          }
          .label {
           font-size: 12px;
           padding: 3px;
        }
      .value {
        font-size: 12px;
         padding: 3px;
      }
          .timestamp-section {
            display: flex;
            justify-content: space-between;
            font-size: 10px;
            color: #858585;
            border-top: 1px solid #e0e0e0;
            padding-top: 5px;
          }
          
          @media print {
            .footer-section {
              position: fixed;
              bottom: 15mm;
              left: 15mm;
              right: 15mm;
            }
            
            .field-value {
              background: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .section-box {
              background: #f8fafc !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .section-title {
              background-color: #EAEBEF !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
              .mt-20{
              margin-top:20px;
              }
          }
        `}
      </style>
    </div>
    </div>
  );
};

export default ProductInformationSheet;